module.exports = __webpack_public_path__ + "img/emsps-dark.24051d67.webp";